import { GradeRounded, ShoppingBagRounded, LocalActivityRounded, AccountCircleRounded, EqualizerRounded, QrCodeScannerRounded, PaidRounded, StorefrontRounded } from "@mui/icons-material";

export const API_URL = "https://demo.api.mygospelpass.com";

export const AccessList = [
    {label:'Ajouter et gérer des billets', button_title:'Billets', ref:"/billets", icon:<LocalActivityRounded />, actions:[
        'Affichage et tri des billets',
        'Créer un billet',
        'Modifier un billet',
        'Supprimer un billet',
        'Envoyer un billet par email',
        // 'Exporter des billets'
    ]},
    {label:'Analyses et Statistiques', button_title:'Analyses', ref:'/statistiques', icon:<EqualizerRounded />, actions:[
        'Affichage des statistiques',
        'Filtrer les statistiques',
        'Statistiques sur les ventes de billets',
    ]},
    {label: 'Scanner des billets', button_title:'Scanner', ref:'/scanner', icon:<QrCodeScannerRounded />, actions:[
        'Scanner des billets',
        'Valider ou annuler un billet scanné',
        'Afficher les détails d’un billet scanné',
    ]},
    {label: 'Guichet/Billetterie sur place', button_title:'Guichet', ref:'/guichet', icon:<StorefrontRounded />, actions:[
        'Afficher les commandes',
        'Créer des commandes',
        'Envoyer les documents d\'une commande',
        'Valider ou annuler une commande',
        'Afficher les détails d’une commande',
    ]},
    {label: 'Demande de paiement', button_title:'Paiement', ref:'/paiements', icon:<PaidRounded />, actions:[
        'Faire une demande de paiement',
        'Afficher mes demandes de paiement',
        'Suivre mes demandes de paiement',
        'Historique des paiements',
    ]},
]

export const SuperAdmAccessList = [
    {label:'Consulter et gérer des commandes ', button_title:'Commandes', ref:"/commandes", icon:<ShoppingBagRounded />, actions:[
        'Affichage et filtrage des commandes',
        'Modifier une commande',
        'Valider ou annuler une commande',
        'Supprimer une commande',
        // 'Exporter des commandes'
    ]},
    {label: 'Gestion des évènements', button_title:'Évènements', ref:"/event", icon:<GradeRounded />, actions:[
        'Affichage et filtrage des évènements',
        'Créer un évènement',
        'Modifier un évènement',
        'Supprimer un évènement',
        // 'Exporter des évènements'
    ]},
    {label: 'Gestion des utilisateurs', button_title:'Utilisateurs', ref:"/users", icon:<AccountCircleRounded />, actions:[
        'Affichage des utilisateurs',
        'Créer un utilisateur',
        'Modifier un utilisateur',
        'Réinitialiser le mot de passe d’un utilisateur',
        'Gérer les accès d’un utilisateur',
        'Activer ou désactiver le mode Admin d’un utilisateur',
        'Supprimer un utilisateur',
        // 'Exporter des utilisateurs'
    ]},
]